import IconAttention from '@/assets/icons/ic_logic-g-app_attention.svg'

import { Button } from '../ui/button'
import { Modal, ModalProps } from './Modal'

interface Props extends ModalProps {
  onOk: () => void
}

export const ConfirmEditQRCodeExpTime = ({
  isOpen,
  onOk,
  onRequestClose,
  ...rest
}: Props): JSX.Element => {
  return (
    <Modal
      isOpen={isOpen}
      customStyles={{
        content: {
          padding: '48px 35px',
          width: 600,
        },
      }}
      onRequestClose={onRequestClose}
      {...rest}
    >
      <h3 className="mb-[15px] mt-[10px] text-center text-2xl font-bold tracking-widest text-primary-text">
        本当に有効期限を変更しますか？
      </h3>

      <div className="my-5 flex justify-center text-[#D7DDF3]">
        <IconAttention width={104} aria-hidden={true} />
      </div>

      <p className="text-center text-[15px] font-medium tracking-widest text-secondary-text">
        有効期限を長く設定すると、不正アクセスのリスクが高まる可能性があります。セキュリティリスクをご理解いただいた上で、自己責任において設定を行ってください。
      </p>

      <div className="mt-10 flex justify-center gap-4">
        <Button variant="secondary" className="w-full max-w-[200px]" onClick={onOk}>
          変更する
        </Button>
      </div>
    </Modal>
  )
}
